import Statusbar from '../../Statusbar';
import decodeHTMLEntities from '../../utils/decodeHTMLEntities';
import Contest from '../../Contest';
import Animation from '../../Animation';
import simpleBarrier from 'simple-barrier';
import showNotificationCentered from '../../utils/showNotificationCentered';

export default function userExecutor({
	name = '',
	avatar = '',
	text = '',
	variation = 'default',
	animation = '',
	duration = 10,
	mode = 'member',
}, done) {
	// eslint-disable-next-line max-len
	log(`Notifications.doUser "${name}" ("${text}") with avatar ${avatar} and variation ${variation} in mode ${mode} and animation ${animation} for ${duration}s`);

	Statusbar.addStatus({ title: text, subtitle: name, avatar });

	switch (animation) {
	case 'sun_rays':
		return doUserRays({ text, avatar, name, duration }, done);
	case 'splash_in':
		return doUserSplash({ text, avatar, name, duration, mode }, done);
	default:
		return doUserDefault({ text, avatar, name, animation, duration }, done);
	}

}

function doUserRays({ text, avatar, name, duration }, done) {
	const textLines = text.split(/\n/);
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template +=
				`<div class="user-avatar-wrap">
					<div class="user-avatar-rays"></div>
					<div class="user-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>
				</div>`;
	}

	template += `<h1>${name}</h1>`;
	$.each(textLines, function(index, line) {
		template += `<p>${line}</p>`;
	});
	template += '</div>';

	const el = $(template);

	return showNotificationCentered(el, duration, done);
}

function doUserDefault({ text, avatar, name, animation, duration }, done) {
	let template = '<div class="notification-user-default">';
	if (avatar) {
		template +=
			`<div class="user-avatar-wrap">
			<div class="user-avatar"><img class="user-avatar-img" src="${avatar}" alt="" /></div>
			</div>`;
	}
	template +=
		`<h1>${name}</h1>
		<p>${text}</p>
		</div>`;
	const el = $(template);

	// Background Animation
	if (animation) {
		const barrier = simpleBarrier();
		const animationForceEnd = showNotificationCentered(el, duration, barrier.waitOn());
		const backgroundForceEnd = Animation.init(animation, duration, barrier.waitOn());

		barrier.endWith(() => {
			done?.();
		});

		return () => {
			animationForceEnd();
			backgroundForceEnd();
		};
	} else {
		return showNotificationCentered(el, duration, done);
	}
}

function doUserSplash({ text, avatar, name, duration, mode }, done) {
	const decodedText = decodeHTMLEntities(text);

	const data = {
		items: [{
			name: name,
			avatar: avatar,
		}],
		target: {
			formatted_value: decodedText,
		},
		duration,
		mode,
	};

	Screen.changeMode('contest');
	Contest.start(data, done);

	return () => {
		Screen.changeMode('slides');
	};
}
